export const updateCurProductAction = (state) => {
  return {
    type: "UPDATE_CURRENT_PRODUCT",
    payload: state,
  };
};
